import { BaseComunicationProvider } from './basecomunication';
import { Injectable } from '@angular/core';

import { Championship } from '../entities/championship';
import { Team } from '../entities/team';

export { Championship, Team }

@Injectable()
export class ChampionshipService extends BaseComunicationProvider {
    public address: string = "ChampionshipHandler.ashx"; 

    getOpened() {
        return new Promise((resolve, reject) => {
            this.sendDataHttp("GetOpened", JSON.stringify(""))
              .then(data => {
                var json: any = data;
                resolve(<Championship[]>json.Item);
              }).catch((err) => {
                  reject(err);
              });
            })
    }

    getTeams(championshipId: number) {
      return new Promise((resolve, reject) => {
          this.sendDataHttp("GetTeams", JSON.stringify({Value: championshipId}))
            .then(data => {
              var json: any = data;
              resolve(<Championship[]>json.Item);
            }).catch((err) => {
                reject(err);
            });
          })
  }

}


// WEBPACK FOOTER //
// ./src/providers/championship.ts